module.exports = __webpack_public_path__ + "img/s9on.8e9c4545.svg";